import { html } from '@oskecare/fe-utilities/lib/LitElement/index.js';
import { config } from '../config.js';

export default function renderNotFoundPageTemplate() {
  return html`
    <div class="section bg-black vertical-stretch">
      <div class="container">
        <div class="grid align-items-center">
          <div class="grid__col--md-6 grid__col--lg-5 grid__col--xl-4">
            <h1 class="display-2">Uuuuups!</h1>
            <p class="bold">
              Stratili ste spojenie so Zemou. Stránku, ktorú hľadáte sa nepodarilo nájsť. Vráťte sa
              na našu základňu.
            </p>
            <a href=${config.basePath} class="btn">Späť na domovskú stránku</a>
          </div>
          <div class="grid__col--1 grid__col--sm-3 grid__col--md-1 grid__col--lg-2"></div>
          <div class="grid__col--10 grid__col--sm-6 grid__col--md-5 grid__col--lg-4 align-center">
            <img class="img" src="assets/images/illustrative-404.png" alt="" />
          </div>
        </div>
      </div>
    </div>
  `;
}
